// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1GHw1","tab":"Tabs_tab__FDD9y","tabActive":"Tabs_tabActive__rJGw0"};